import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService} from './auth.service';

@Injectable()
export class LoginService {
  errorText: string = "";
  successText: string = "";
  choosedLogin: boolean = true;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };

  constructor(private http: HttpClient,  private authService: AuthService) {
    
  }

  getUser(userInfo) {
    this.errorText = "";
    let params = {
      "login": userInfo.login,
      "userPassword": userInfo.password
    }

    this.http.post(this.authService.databaseURL+'getdata.php?table=user', params, this.httpOptions).subscribe(
      (data:any[]) => {
        if(data.length == 1){
          for(let i = 0; i < 1; i++){
            localStorage.setItem("idUser", data[i].id);
            localStorage.setItem("loginUser", data[i].login);
            localStorage.setItem("settingsUser", data[i].settings);
            localStorage.setItem("emailUser", data[i].email);
            localStorage.setItem("stateUser", data[i].state);
            localStorage.setItem("menuImage", data[i].menuImage);

          }
          this.authService.login();
        }
        else{
          this.errorText = "Nesprávné přihlašovací údaje.";
        }
      }
    )
  }

  addUser(newUser){
    this.errorText = "";

    let  dateNow = Date.now().toString();

    let params = {
      "id": "U" + newUser.login.slice(0,25 - dateNow.length) + dateNow,
      "idNote": "N" + dateNow + "-" + dateNow.slice(-23 + dateNow.length),
      "idProject": "",
      "login": newUser.login,
      "userPassword": newUser.password,
      "settings": 0,
      "email": newUser.email,
      "state": 0
    }
    params.idProject = "UL" + params.id.slice(-20);

    this.http.post(this.authService.databaseURL+'getdata.php?table=userLogin', params, this.httpOptions).subscribe(
      (data:any[]) => {
        if(data.length > 0){
          this.errorText = "Login je již zaregistrován jiným uživatelem.";
        }
        else{
          this.http.post(this.authService.databaseURL+'adddata.php?table=user', params, this.httpOptions).subscribe(
            (data:any[]) => {
              this.successText = "Registrace proběhla úspěšně, nyní se můžete přihlásit.";
              this.choosedLogin = true;
              this.errorText = "";
            }
            
          );
        }
      }
    )
  
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/login.service.ts